/*  eslint-disable no-use-before-define */

/*
 * Defining core Wrex types
 * (based of slate types)
 */

/**
 * Text node holding the text (an optionally some attributes)
 * @internal
 */
export interface Text {
    text: string;
    [key: string]: any;
}

/**
 * The available alignment for a block
 * @internal
 */
export enum Alignment {
    START = 'start',
    CENTER = 'center',
    END = 'end',
}

/**
 * Element node holding children and additional attributes based on the type
 * @internal
 */
export interface Element<T extends string = string> {
    type: T;
    children: Node[];
}

/**
 * Wrex node = text or element
 * @internal
 */
export type Node = Text | Element;

/**
 * Array of Wrex nodes
 */
export type Nodes = Array<Node>;

/**
 * Wrex document
 */
export type Document = { children: Nodes };

/**
 * Get element attribute from an element by omitting the `type` and `children`.
 */
export type ElementAttributes<E extends Element> = Omit<E, 'type' | 'children'>;
